import '@babel/polyfill'
import 'mutationobserver-shim'
import Vue from 'vue'
import './plugins/bootstrap-vue'
import App from './App.vue'
import VueRouter from 'vue-router'
import vuetify from './plugins/vuetify';
import store from './store'
import Login from './components/Login.vue';
import Phone from './components/Phone.vue';
import Home from './pages/Home.vue';
import Ligacao from './pages/Ligacao';
import Chat from './components/Chat.vue';
import Clientes from './components/Clientes.vue';
import Historico from './pages/Historico';
import Contatos from './pages/Contatos';
import Chat2 from './components/ChatH.vue';
// import 'bootstrap/dist/css/bootstrap.css'
// import 'bootstrap-vue/dist/bootstrap-vue.css'
// import './assets/quill.css';
import VueTranslate from 'vue-translate-plugin';
import VueLodash from 'vue-lodash'
import lodash from 'lodash'
import './registerServiceWorker'
//import Dashboard from './components/Dashboard.vue'

Vue.use(VueLodash, { name: 'custom', lodash: lodash })
Vue.use(VueTranslate);


Vue.config.productionTip = false
Vue.use(VueRouter)
const routes = [
  { path: '/', component: Login, name: `login`, meta: { requireAuth: true } },
  { path: '/home', component: Home, name: `home`, meta: { requireAuth: true } },
  { path: '/ligacao', component: Ligacao, meta: { requireAuth: true } },
  { path: '/ligacao:numero', component: Ligacao, meta: { requireAuth: true } },
  { path: '/historico', component: Historico, meta: { requireAuth: true } },
  { path: '/contatos', component: Contatos, meta: { requireAuth: true } },

  { path: '/clientes', component: Clientes, meta: { requireAuth: true } },
  { path: '/chat', component: Chat, meta: { requireAuth: true } },
  { path: '/chat2', component: Chat2, meta: { requireAuth: true } },

  { path: '/login', component: Login },
  { path: '/phone', component: Phone, meta: { requireAuth: true } },
  // { path: '/Dashboard', component: Dashboard, meta: { requireAuth: true } }

];
const router = new VueRouter({
  routes // short for `routes: routes`
})
router.beforeEach((to, from, next) => {
  if (to.meta.requireAuth) {
    if (!store.state.auth.isLogged) {
      next({
        path: '/login',
        query: { redirect: to.fullPath }
      })
    } else {
      next();
    }
  } else {
    next();
  }
})

// Vue.config.errorHandler = function (err, vm, info) {
//   console.log(`Error123: ${err.toString()}\nInfo: ${info}`);
//   saveToLog(options,
//     "xcontact.txt",
//     `${new Date()} [GLOBAL CATCHER ERROR] ` + err
//   );
// };
new Vue({
  store,
  router,
  vuetify,
  render: h => h(App),
}).$mount('#app')
